import { i18n } from '@/plugins/i18n';
import '@babel/polyfill';
import 'material-design-icons/iconfont/material-icons.css';
import 'typeface-roboto/index.css';
import money from 'v-money';
import Vue from 'vue';
import App from './App.vue';
import { auth } from './firebaseConfig';
import './plugins/vuetify';
import './registerServiceWorker';
import router from './router';
import store from './store';
import './styles.css';

Vue.use(money);

Vue.config.productionTip = false;
let app: Vue;

auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      i18n,
      store,
      render: h => h(App)
    });
  }
  store.dispatch('setUser', user).then(res => {
    navigate(res);
  });
});

function navigate(val) {
  console.log(val);
  if (val && val.isEmployer) {
    // an employer
    router.replace('employerHome');
  } else if (val && val.isEmployee) {
    // an employee
    router.replace('employeeHome');
  } else if (val) {
    // logged in but not an employer / employee
    router.replace('loginas');
  } else {
    // no current user, thus need to login first
    router.replace('login');
  }
}
